// extracted by mini-css-extract-plugin
export default {"addButton":"FamilyScreen_addButton__qsnQE","sectionOption":"FamilyScreen_sectionOption__e4WMF"};